/*=============================
=          Google Map         =
=============================*/
var apiKey = 'AIzaSyC92B6UkvENCEOmlLzmo7uoOD3IB0z9nR0';
var mapContainer = document.querySelector('.map-container');

function initMapSmall() {
    var strCoordinates = mapContainer && mapContainer.hasAttribute('data-coordinates') ? mapContainer.getAttribute('data-coordinates') : '29.7107851,-95.4006464',
        coordinates = JSON.parse('[' + strCoordinates + ']'),
        latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
        mapOptions = {
            zoom: 15,
            streetViewControl: false, // hide the yellow Street View pegman
            scaleControl: true, // allow users to zoom the Google Map
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            disableDefaultUI: true,
            center: latLng,
            styles: mapStyles
        },
        map = new google.maps.Map(mapContainer, mapOptions),
        marker = new google.maps.Marker({
            position: latLng,
            map: map
        });
}

window.mapWaypoint = function mapWaypoint(map) {

    var mapWaypoint = new Waypoint({
        element: map,
        handler: function (direction) {
            var script = document.createElement('script');

            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initMap&libraries=geometry';
            script.type = 'text/javascript';
            script.setAttribute('async', 'true');
            script.setAttribute('defer', 'true');

            document.body.appendChild(script);

            this.destroy();
        },
        offset: '150%'
    });
}

if (mapContainer) {
    mapWaypoint(mapContainer);

    window.initMap = initMapSmall;
}


/*=============================
=           Finder          =
=============================*/

var finder = document.querySelector('body#finder');

if (finder) {
    var locationsTab = document.querySelector('.tab.locations-tab'),
        physiciansTab = document.querySelector('.tab.physicians-tab')
    locationsTabButton = document.querySelector('.tab-button.locations'),
        physiciansTabButton = document.querySelector('.tab-button.physicians'),
        formPhysicians = document.querySelector('form.form-physicians'),
        formLocations = document.querySelector('form.form-locations')
    physicianCards = document.querySelectorAll('.physician-card'),
        heroText = document.querySelector('#hero .title'),
        locationsAccordionDivs = document.querySelectorAll('.locations-flex .accordion .region-group > div');

    const showTabCondition = window.location.hash === '#location';
    processTabs(showTabCondition);

    if (document.querySelector('.tab-button'))
        document.querySelectorAll('.tab-button').forEach(item => {
            item.addEventListener('click', setActiveTab)
        });

    function setActiveTab(e) {
        e.preventDefault();
        const tabHref = this.getAttribute('href'),
            showTabCondition = tabHref === '#location';

        processTabs(showTabCondition);
    }

    if (formPhysicians) formPhysicians.addEventListener('submit', formProcessFinder);
    if (formLocations) formLocations.addEventListener('submit', formProcessFinder);

    function formProcessFinder(e) {
        e.preventDefault();

        let url = new URL(window.location.href);
        var searchParams = url.searchParams;

        var form = this,
            locationsSelect = this.querySelector('.locations-select'),
            physiciansSelect = this.querySelector('.physicians-select'),
            cityInput = this.querySelector('.city-input'),
            clearSearch = this.querySelector('.clear-search');
        [cityInput, physiciansSelect, locationsSelect].forEach((el) => {
            if (el !== null) {
                const elValue = el.value;
                const elParam = el.classList[0].split('-')[0];

                if (elValue != 0) {
                    searchParams.delete(elParam);
                    searchParams.append(elParam, elValue);
                } else {
                    searchParams.delete(elParam);
                }
            }
        });

        window.history.replaceState(null, null, url);

        if (form.classList[0] == 'form-locations') {
            submitLocationsForm();

            if (cityInput.value != '' || physiciansSelect.value != 0) {
                clearSearch.style.opacity = '1';
            } else {
                clearSearch.style.opacity = '0';
            }
        } else {
            submitPhysiciansForm();

            if (locationsSelect.value != 0) {
                clearSearch.style.opacity = '1';
            } else {
                clearSearch.style.opacity = '0';
            }
        }
    }

    function submitLocationsForm() {
        let url = new URL(window.location.href);
        var searchParams = url.searchParams;

        locationsAccordionDivs.forEach((locationAcc) => {
            var locationAccPhysicians = JSON.parse(locationAcc.getAttribute('data-physicians'));

            ['physicians'].forEach((el) => {
                if (searchParams.has(el)) {
                    document.querySelectorAll('.' + el + '-select').forEach(function (formEl) {
                        formEl.value = searchParams.get(el);
                    });
                }
            });

            if (searchParams.get('city')) {
                document.querySelector('.city-input').value = searchParams.get('city');
            }

            if ((searchParams.get('physicians') === null || locationAccPhysicians.includes(searchParams.get('physicians')))
            ) {
                locationAcc.classList.remove('hide');
            } else {
                locationAcc.classList.add('hide');
            }
        });

        if (typeof google !== 'undefined') {
            initMapFinder();
        } else {
            setTimeout(() => {
                initMapFinder();
            }, 1500);
        }

        var locationsCountCollection = document.querySelector('.locationsCount').value,
            locationsText = document.querySelector('.finder-locations-text');

        setTimeout(() => {
            if (locationsCountCollection == document.querySelectorAll('.locations-flex .accordion .region-group > div:not(.hide)').length) {
                locationsText.innerHTML = 'Showing all locations';
            } else if (document.querySelectorAll('.locations-flex .accordion .region-group > div:not(.hide)').length <= 0) {
                locationsText.innerHTML = 'No locations found';
            } else {
                locationsText.innerHTML = 'Showing ' + document.querySelectorAll('.locations-flex .accordion .region-group > div:not(.hide)').length + ' locations';
            }
        }, 500);
    }

    submitLocationsForm();

    function submitPhysiciansForm() {
        let url = new URL(window.location.href);
        var searchParams = url.searchParams;


        physicianCards.forEach((physicianCard) => {
            var physicianCardLocations = physicianCard.getAttribute('data-locations') != null ? physicianCard.getAttribute('data-locations').split(',') : '';

            ['locations'].forEach((el) => {
                if (searchParams.has(el)) {
                    document.querySelectorAll('.' + el + '-select').forEach(function (formEl) {
                        formEl.value = searchParams.get(el);
                    });
                }
            });

            if ((searchParams.get('locations') === null || physicianCardLocations.includes(searchParams.get('locations')))
            ) {
                physicianCard.classList.remove('hide');
            } else {
                physicianCard.classList.add('hide');
            }
        });

        var physiciansCountCollection = document.querySelector('.physiciansCount').value,
            physiciansText = document.querySelector('.finder-physician-text');

        setTimeout(() => {
            if (physiciansCountCollection == document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length) {
                physiciansText.innerHTML = 'Showing all physicians';
            } else if (document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length <= 0) {
                physiciansText.innerHTML = 'No physicians found';
            } else {
                physiciansText.innerHTML = 'Showing ' + document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length + ' physicians';
            }
        }, 500);
    }

    submitPhysiciansForm();

    function processTabs(showTabCondition) {


        if (showTabCondition) {
            locationsTab.classList.add('active');
            locationsTabButton.classList.add('active');

            physiciansTab.classList.remove('active');
            physiciansTabButton.classList.remove('active');

            document.querySelector('.locations-select').value = 0;

            window.location.hash = '#location';
            heroText.innerHTML = 'Search Locations';

            if (typeof google !== 'undefined') {
                initMapFinder();
            } else {
                setTimeout(() => {
                    initMapFinder();
                }, 1500);
            }
        } else {
            physiciansTab.classList.add('active');
            physiciansTabButton.classList.add('active');

            locationsTab.classList.remove('active');
            locationsTabButton.classList.remove('active');

            document.querySelector('.physicians-select').value = 0;
            document.querySelector('.city-input').value = '';
            window.location.hash = '#physician';
            heroText.innerHTML = 'Search Physicians';
        }
    }

    function initMapFinder() {
        let url = new URL(window.location.href);
        var searchParams = url.searchParams;


        var strCoordinates = mapContainer && mapContainer.hasAttribute('data-coordinates') ? mapContainer.getAttribute('data-coordinates') : '28.7107851,-94.4006464',
            coordinates = JSON.parse('[' + strCoordinates + ']'),
            latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
            mapOptions = {
                zoom: 15,
                streetViewControl: false, // hide the yellow Street View pegman
                scaleControl: true, // allow users to zoom the Google Map
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                disableDefaultUI: true,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: google.maps.ControlPosition.TOP_CENTER,
                },
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER,
                },
                center: latLng,
                styles: mapStyles
            },
            map = new google.maps.Map(mapContainer, mapOptions);

        var i = 0;
        var cityAddress = '';

        if (searchParams.get('city') == 'Current Location') {
            let url = new URL(window.location.href);
            const searchParams = url.searchParams;
            cityAddress = searchParams.get('pos');
        } else {
            // cityAddress = searchParams.get('city') + ' tennessee';
            cityAddress = searchParams.get('city');

        }

        var bounds = new google.maps.LatLngBounds(),
            radius = parseInt(450, 10) * 1000,
            geocoder = new google.maps.Geocoder(),
            openWindow,
            gmarkers = [];
        document.querySelectorAll('.locations-flex .accordion .region-group > div:not(.hide)').forEach(function (location) {
            var coordinates = location.getAttribute('data-coords').split(','),
                location_code = location.getAttribute('area_code').split(','),
                latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
                a_code = location_code[0],
                infowindow = new google.maps.InfoWindow({
                    position: latLng,
                    content: '<h4>' + location.querySelector('button h4').innerHTML + '</h4>' + location.querySelector('.answer div .details').innerHTML
                }),
                pin = '/assets/images/icons/finder_pin_' + a_code + '.svg';
            marker = new google.maps.Marker({
                map: map,
                position: latLng,
                draggable: false,
                animation: google.maps.Animation.DROP,
                icon: pin
            });

            gmarkers.push(marker);
            (function (marker, infowindow) {

                marker.addListener('click', function () {
                    if (openWindow) {
                        openWindow.close();
                        currentMarker.setIcon(pin);
                    }

                    if (checkWidth(768))
                        mapContainer.classList.remove('info-closed');

                    infowindow.open(map, marker);
                    openWindow = infowindow;

                    marker.setIcon('/assets/images/icons/finder_pin_current.svg');
                    currentMarker = marker;
                    document.querySelectorAll('.locations-flex .accordion .region-group > div').forEach(function (el, key) {
                        var markerCoords = marker.getPosition().lat() + ',' + marker.getPosition().lng();

                        if (el.getAttribute('data-coords') == markerCoords) {
                            if (!document.querySelector('.locations-flex .accordion .region-group > div[data-coords="' + markerCoords + '"] button').classList.contains('open')) {
                                document.querySelector('.locations-flex .accordion .region-group > div[data-coords="' + markerCoords + '"] button').click();
                            }
                        }
                    });
                });

                infowindow.addListener('closeclick', function () {
                    marker.setIcon(pin);
                    mapContainer.classList.add('info-closed');
                });
            })(marker, infowindow);
            marker.setIcon(pin);
            bounds.extend(latLng);
        });


        document.querySelectorAll('.locations-flex .accordion .region-group > div').forEach(function (el, key) {
            el.addEventListener('click', function (e) {

                gmarkers.forEach(function (marker) {
                    var markerCoords = marker.getPosition().lat() + ',' + marker.getPosition().lng();

                    if (el.getAttribute('data-coords') == markerCoords && !checkWidth(768)) {
                        new google.maps.event.trigger(marker, 'click');
                    }
                });

                if (!checkWidth(768)) {
                    document.querySelector('.locations-flex .accordion').scrollTop = key * 70;
                }
            });
        });


        if (searchParams.get('city') != null) {
            geocoder.geocode({'address': cityAddress}, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    // map.setCenter(results[0].geometry.location);
                    var bounds = new google.maps.LatLngBounds(),
                        pin = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location
                        });

                    for (var i = 0; i < gmarkers.length; i++) {
                        var gmarkerCoords = new google.maps.LatLng(gmarkers[i].getPosition().lat(), gmarkers[i].getPosition().lng()),
                            markerDistance = google.maps.geometry.spherical.computeDistanceBetween(pin.getPosition(), gmarkerCoords);

                        gmarkers[i]['markerDistance'] = markerDistance;
                    }

                    gmarkers.sort((a, b) => (a.markerDistance > b.markerDistance) ? 1 : -1);

                    gmarkers.forEach((gmarker, index) => {
                        var dataCoords = gmarker.position.lat() + ',' + gmarker.position.lng();


                        document.querySelectorAll('.locations-flex .accordion .region-group > div').forEach(function (accord) {
                            if (dataCoords == accord.getAttribute('data-coords')) {
                                accord.style.order = index;
                                if (gmarker.markerDistance < radius && index <= 4) {
                                    gmarker.setVisible(true);
                                    bounds.extend(latLng);
                                } else {
                                    document.querySelector('.locations-flex .accordion .region-group > div[data-coords="' + dataCoords + '"]').classList.add('hide');
                                    gmarker.setVisible(false);
                                }
                            }
                        });
                    });

                } else {
                    alert('Geocode was not successful for the following reason: ' + status);
                }
            });
        }

        map.fitBounds(bounds);
    }

    document.querySelector('.use-location').addEventListener("click", () => {
        let url = new URL(window.location.href);
        var searchParams = url.searchParams;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    document.querySelector('.city-input').value = 'Current Location';
                    searchParams.delete('pos');
                    searchParams.append('pos', position.coords.latitude + ',' + position.coords.longitude);
                    window.history.replaceState(null, null, url);
                },
                (error) => {
                    alert('Error while getting current location: ' + error.message);
                }
            );
        } else {
            alert('Browser doesn\'t support Geolocation');
        }
    });

    document.querySelector('.find-by-location').addEventListener('click', () => {
        document.querySelector('.button.locations.tab-button').click();
    });

    document.querySelectorAll('.clear-search').forEach(function (clearSearch) {
        clearSearch.addEventListener('click', function (e) {
            let url = new URL(window.location.href);
            var searchParams = url.searchParams;

            ['physicians', 'locations', 'city', 'pos'].forEach((el) => {
                searchParams.delete(el);
            });

            document.querySelector('.physicians-select').value = 0;
            document.querySelector('.locations-select').value = 0;

            document.querySelector('.city-input').value = '';
            window.history.replaceState(null, null, url);

            e.target.style.opacity = '0';

            e.target.previousSibling.click();
        });
    });

    if (document.querySelector('.tab-button.physicians').classList.contains('active')) {
        formPhysicians.querySelector('button[type=submit]').click();
    } else if (document.querySelector('.tab-button.locations').classList.contains('active')) {
        formLocations.querySelector('button[type=submit]').click();
    }


}


var clipboard = new ClipboardJS('.copy-to-clipboard');

clipboard.on('success', function (e) {
    console.log('text copied to clipboard', e.text);

});
clipboard.on('error', function (e) {
    console.error('Text copy failed:', e.trigger);
});
